import demandService from '@/service/demand';
import { toggleValue } from '@/store';
import localforage from 'localforage';
import { isEmpty } from 'lodash';
import { observable, action, runInAction } from 'mobx';


// 获取人均福利分布

const moIndustry = observable({
  industryType: 'chart',
  industryActive: 'hot',
  trendActive: 'year',
  trendType: 'chart',
  hotIndustryList: <any>[],
  totalHotIndustryList: <any>{},
  trendYear: <any>{},
  trendQuarter: <any>[],
  trendMonth: <any>[],
  industryTrendList: <any>[],
});

// 切换行业招聘热度表格图表

const changeHotType = action(async (val: string) => {
  runInAction(() => {
    moIndustry.industryType = val;
  })
  const local: any = await localforage.getItem('demand') || {};
  local['industryType'] = val;
  localforage.setItem('demand', local)
})

// 切换行业招聘热度tab

const changeHotActive = action(async (val: string) => {
  runInAction(() => {
    moIndustry.industryActive = val;
  })
  const local: any = await localforage.getItem('demand') || {};
  local['industryActive'] = val;
  localforage.setItem('demand', local)
})

// 切换招聘趋势表格图表

const changeTrendType = action(async (val: string) => {
  runInAction(() => {
    moIndustry.trendType = val;
  })
  const local: any = await localforage.getItem('demand') || {};
  local['trendType'] = val;
  localforage.setItem('demand', local)
})

// 切换招聘趋势tab

const changeTrendActive = action(async (val: string) => {
  runInAction(() => {
    moIndustry.trendActive = val;
  })
  const local: any = await localforage.getItem('demand') || {};
  local['trendActive'] = val;
  localforage.setItem('demand', local)
})

// 招聘趋势

const getTrendYear = action(async () => {
  const trendYear = await demandService.getIndustryTrendYear()
  runInAction(() => {
    moIndustry.trendYear = trendYear;
  })

})

const getTrendQuarter = action(async () => {
  const trendQuarter = await demandService.getIndustryTrendQuarter()
  runInAction(() => {
    moIndustry.trendQuarter = trendQuarter;
  })
})
const getTrendMonth = action(async () => {
  const trendMonth = await demandService.getIndustryTrendMonth()
  runInAction(() => {
    moIndustry.trendMonth = trendMonth;
  })
})

// 招聘热度

const getHotIndustry = action(async () => {
  const industryHotList = await demandService.getIndustryHot();
  runInAction(() => {
    moIndustry.hotIndustryList = industryHotList.multi_industry_data;
    moIndustry.totalHotIndustryList = industryHotList.total_industry_data
  })
})

// 招聘趋势

const getIndustryTrend = action(async () => {
  const industryTrendList = await demandService.getIndustryTrend();
  runInAction(() => {
    moIndustry.industryTrendList = industryTrendList;
  })
})

export default moIndustry;
export {
  changeHotType, changeHotActive, changeTrendType, changeTrendActive, getTrendYear, getTrendQuarter,
  getTrendMonth, getHotIndustry, getIndustryTrend
};
